module.exports = (__parcel__import__("dr88n")).then(() => parcelRequire('lkF08'));